import { ref } from "vue";
import { defineStore } from "pinia";

export const useRouterStore = defineStore("router", () => {
  const routerName = ref("/");

  const setRouterName = (name) => {
    routerName.value = name;
  };

  return {
    routerName,
    setRouterName,
  };
});
